import { type JSX } from 'react/jsx-dev-runtime';

import { Button, cn } from '@videoblocks/design-system';
import { Refresh, WarningTriangle } from '@videoblocks/design-system/icons';

import { GenerationFlowLayout } from './GenerationFlowLayout';

export interface GenerationFlowErrorLayoutProps {
    title?: string;
    subtitle?: string;
    onConfirm?: () => void;
    isValid?: boolean;
    className?: string;
    /** When false the failure is the user's to fix (e.g. moderation) — the Retry button is hidden */
    canRetry?: boolean;
}

export const GenerationFlowErrorLayout = ({
    title = 'Generation timed out',
    subtitle = 'This request took longer than expected. Please try again.',
    onConfirm,
    isValid,
    className,
    canRetry = true,
}: GenerationFlowErrorLayoutProps): JSX.Element => {
    const ErrorIcon = (
        <WarningTriangle
            className="size-8 dark:[&_path]:fill-neutral-dark-1000"
            data-testid="video-generation-error-icon"
        />
    );
    return (
        <GenerationFlowLayout
            className={cn('w-full h-full gap-5', className)}
            title={title}
            subtitle={subtitle}
            icon={ErrorIcon}
        >
            {canRetry && (
                <Button
                    buttonClassName="group"
                    iconPrefix={
                        <Refresh className="size-4 dark:[&_path]:fill-neutral-dark-1000 dark:group-hover:[&_path]:fill-black dark:group-disabled:[&_path]:fill-neutral-dark-600 dark:group-disabled:group-hover:[&_path]:fill-neutral-dark-600" />
                    }
                    onClick={() => {
                        onConfirm?.();
                    }}
                    disabled={!isValid}
                    variant="outlined-light"
                >
                    Retry
                </Button>
            )}
        </GenerationFlowLayout>
    );
};
